import React from "react";

function Icon({color = '#F8FAF9', ...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      fill="none"
      viewBox="0 0 27 28"
      {...props}
    >
      <path
        fill={color}
        d="M13.5.667C6.136.667.166 6.637.166 14c0 6.655 4.876 12.17 11.25 13.172v-9.319H8.03V14h3.387v-2.937c0-3.342 1.99-5.187 5.036-5.187 1.459 0 2.984.26 2.984.26v3.28h-1.68c-1.657 0-2.173 1.028-2.173 2.083V14h3.697l-.59 3.853h-3.107v9.32c6.373-1 11.249-6.52 11.249-13.173C26.833 6.636 20.863.667 13.5.667z"
      ></path>
    </svg>
  );
}

export default Icon;
